<div class="loaderwrapper" *ngIf="loader">
    <span class="loader"></span>
</div>

<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="col-12">
            <div class="card table-card">
                <!-- Title, filters and the page action share one row at the top
                     of the card rather than stacking above it. -->
                <div class="table-toolbar">
                    <h1 class="table-toolbar__title">Priority</h1>
                    <div class="sb-filter-holder sb-filter-holder--inline">
                        <div class="btn-group sb-filter-search-group" role="group">
                            <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                                (input)="searchData($event)">
                            <button type="button" class="btn sb-filter-search-btn">
                                <!-- <i class="ri-search-line"></i> -->
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path
                                        d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <button type="button" class="btn btn-dark rounded" (click)="openAddPopUp(content)"
                        *ngIf="permissionsReady && permissions.canAdd">
                        <i class="ri-add-line label-icon align-middle fs-16"></i>
                        Add New
                    </button>
                </div>
                <div class="table-wrap" [class.is-loading]="tableLoader">
                    <div class="loaderwrapper" *ngIf="tableLoader">
                        <span class="loader"></span>
                    </div>
                    <div class="table-main">
                        <div>
                            <table class="table-data">
                                <thead>
                                    <tr>
                                        <th scope="col">Sr No.</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Time</th>
                                        <th scope="col">Default</th>
                                        <th scope="col" style="width: 80px; text-align: center"
                                            *ngIf="hasAnyActionPermission">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of priorityList; let i = index">
                                        <td>{{ item.srNo }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.time }}h</td>
                                        <td>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    [id]="'status-' + item.id" [checked]="item.default"
                                                    (change)="toggleDefaultPriority(item)">
                                                <label class="custom-control-label" [for]="'status-' + item.id"></label>
                                            </div>
                                        </td>
                                        <td *ngIf="hasAnyActionPermission">
                                            <ul class="list-inline hstack gap-2 mb-0">
                                                <!-- *ngIf="permissionsReady && permissions.canDelete" -->
                                                <li class="list-inline-item edit" data-bs-toggle="tooltip"
                                                    data-bs-trigger="hover" data-bs-placement="top" title="Edit"
                                                    *ngIf="permissionsReady && permissions.canEdit">
                                                    <a title="Edit User Type" (click)="openEditPopUp(item, content)"
                                                        class="d-inline-block edit-item-btn">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.433"
                                                            height="18" viewBox="8 4 14.433 18">
                                                            <path
                                                                d="M8.9 20.2h12.6a.9.9 0 0 1 0 1.8H8.9a.9.9 0 1 1 0-1.8ZM8 15.7l9-9 2.7 2.7-9 9H8v-2.7Zm9.9-9.9L19.7 4l2.7 2.7-1.8 1.8-2.7-2.7Z"
                                                                fill="currentColor" />
                                                        </svg>
                                                    </a>
                                                </li>
                                                <li class="list-inline-item delete" data-bs-toggle="tooltip"
                                                    data-bs-trigger="hover" data-bs-placement="top" title="Delete"
                                                    *ngIf="permissionsReady && permissions.canDelete">
                                                    <a title="Delete City" data-bs-toggle="modal"
                                                        class=" d-inline-block edit-item-btn" type="button"
                                                        (click)="deleteRecord(item.id,modalDelete)">
                                                        <!-- <i class=" ri-close-circle-line  "></i>  -->
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15.017"
                                                            height="18" viewBox="9 6 15.017 18">
                                                            <path
                                                                d="M10.5 22.004c0 1.098.9 1.996 2 1.996h8c1.1 0 2-.898 2-1.996V10.5h-12v11.504ZM24 7.5h-3.75L18.994 6h-4.988L12.75 7.5H9V9h15V7.5Z"
                                                                fill="currentColor" />
                                                        </svg>
                                                    </a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <!-- NO VIEW PERMISSION -->
                                    <tr *ngIf="permissionsReady && !permissions.canView">
                                        <td colspan="100%">
                                            <div class="no-access text-center p-4">
                                                You don’t have permission to view this data.
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- NO RECORDS -->
                                    <tr
                                        *ngIf="permissionsReady && permissions.canView && (!priorityList || priorityList.length === 0)">
                                        <td colspan="100%">
                                            <p class="not-found-message p-4 text-center">
                                                No records found.
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-meta">
                            <div class="entries flex-column align-items-start gap-3">
                                <label class="show-entries-list p-0">
                                    Show
                                    <select [formControl]="pageSizeControl" class="form-control form-control-sm"
                                        (change)="changePageSize()">
                                        <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                            {{ limit.label }}
                                        </option>
                                    </select>
                                    Entries
                                </label>
                                <span>Total Records: {{ this.total_items }}</span>
                            </div>
                            <nav class="table-pagination">
                                <ul>
                                    <li>
                                        <div class="go-to-page d-flex align-items-center">
                                            <label>Go to Page:</label>
                                            <input type="number" class="form-control form-control-sm"
                                                [(ngModel)]="pageToGo" min="1" [max]="total_pages"
                                                (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                            <div class="input-group-append">
                                                <button class="btn btn-primary" type="button"
                                                    (click)="goToPage(pageToGo); pageToGo = null"
                                                    [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                            [class.disabled]="current_page === 1">1</a></li>
                                    <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                                class="fa fa-chevron-left"></i></a></li>
                                    <li><a class="active">{{ current_page }}</a></li>
                                    <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                            [class.disabled]="current_page === total_pages"><i
                                                class="fa fa-chevron-right"></i></a></li>
                                    <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                            [class.disabled]="current_page === total_pages">{{ this.total_pages }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Add/Edit Modal -->
<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            {{ isEditMode ? 'Edit Priority' : 'Add Priority' }}
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); resetForm()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>

    <div class="modal-body">
        <form [formGroup]="priorityForm" (ngSubmit)="onSubmit()">
            <div class="row">
                <div class="col-md-12 mb-3 form-styles">
                    <label for="name">Priority Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="name" formControlName="name"
                        placeholder="Enter priority name"
                        [class.is-invalid]="priorityForm.get('name').invalid && priorityForm.get('name').touched">
                    <small class="text-danger"
                        *ngIf="priorityForm.get('name').invalid && priorityForm.get('name').touched">
                        <span *ngIf="priorityForm.get('name').errors?.['required']">Name is required</span>
                        <span *ngIf="priorityForm.get('name').errors?.['minlength']">Name must be at least 2
                            characters</span>
                    </small>
                </div>

                <div class="col-md-12 mb-3 form-styles">
                    <label for="time">Time <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="time" formControlName="time"
                        placeholder="Enter time in hours (e.g., 2.5)"
                        [class.is-invalid]="priorityForm.get('time').invalid && priorityForm.get('time').touched">
                    <small class="text-danger"
                        *ngIf="priorityForm.get('time').invalid && priorityForm.get('time').touched">
                        <span *ngIf="priorityForm.get('time').errors?.['required']">Time is required</span>
                        <span *ngIf="priorityForm.get('time').errors?.['pattern']">Enter valid hours (e.g., 2, 2.5,
                            0.5)</span>
                        <span *ngIf="priorityForm.get('time').errors?.['min']">Time must be greater than 0</span>
                    </small>
                </div>
            </div>
        </form>
    </div>

    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" aria-label="Close"
            (click)="modal.dismiss('Cross click'); resetForm()">Cancel</button>
        <button type="submit" class="btn btn-orange" [disabled]="priorityForm.invalid" (click)="onSubmit()">
            {{ isEditMode ? 'Update' : 'Save' }}
        </button>
    </div>
</ng-template>
<ng-template #modalDelete let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            DELETE
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click');">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="12" fill="white" />
                <path d="M7 7.00024L12.0515 12.0518L17.103 7.00024" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 17.6716L12.0505 12.6201L17.1021 17.6716" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <p class="text-center">Are you sure you want to delete this priority?</p>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click')">
            Cancel
        </button>
        <button type="button" class="btn btn-orange" (click)="c('confirm')" type="submit">
            Delete
        </button>
    </div>
</ng-template>